/**
 * Seriously, menus need to be above everything else.
 */
export const MENU_Z_INDEX = 10000;
export const TIME_FORMAT = "h:mm a";
